import { render, staticRenderFns } from "./SocialReviewsTable.vue?vue&type=template&id=faec8e20&scoped=true&"
import script from "./SocialReviewsTable.vue?vue&type=script&lang=js&"
export * from "./SocialReviewsTable.vue?vue&type=script&lang=js&"
import style0 from "./SocialReviewsTable.vue?vue&type=style&index=0&id=faec8e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faec8e20",
  null
  
)

export default component.exports